import { FC, useMemo } from 'react';
import DistributionBars from '../../../shared/charts/DistributionBars';
import { DistributionSlice } from '../../../shared/charts/chart.types';
import { ITrainingMixCategorySlice } from '../../../models/allenamenti';
import { FALLBACK_CATEGORY_COLOR } from '../allenamenti.constants';
import { formatMinutes } from './analysis.constants';
import Typhography from '../../../shared/Typhography/Typhography';
import styles from './CategoryBars.module.scss';

interface ICategoryBarsProps {
  slices: ITrainingMixCategorySlice[];
  bySlug: Map<string, { labelIt: string; color: string }>;
}

/**
 * Composizione del lavoro per categoria.
 *
 * Barre e NON una torta, ed è la conseguenza diretta di come si contano i
 * minuti: un blocco che sta in più categorie conta i suoi minuti INTERI su
 * ciascuna (decisione 2026-08-18). Le percentuali quindi non sommano a 100, e
 * una torta — che per definizione rappresenta parti di un intero — direbbe il
 * falso. Qui ogni barra si legge per conto suo: «quanta parte del tempo del
 * periodo ha toccato questa categoria».
 */
const CategoryBars: FC<ICategoryBarsProps> = ({ slices, bySlug }) => {
  const data: DistributionSlice[] = useMemo(
    () =>
      slices.map((s) => ({
        id: s.key,
        label: bySlug.get(s.key)?.labelIt ?? s.key,
        value: s.minutes,
        percent: s.percentage,
        color: bySlug.get(s.key)?.color ?? FALLBACK_CATEGORY_COLOR,
      })),
    [slices, bySlug],
  );

  return (
    <div className={styles.card}>
      <Typhography type="h3" size="bold-14" className={styles.title}>
        Composizione per categoria
      </Typhography>
      <DistributionBars data={data} valueFormatter={formatMinutes} labelMode="value-percent" />
      {/* Detto una volta qui invece che scoperto guardando i numeri: senza
          questa riga, un totale che supera il 100% sembra un errore. */}
      <Typhography size="regular-10" className={styles.note}>
        Un blocco può appartenere a più categorie: i suoi minuti contano interi
        su ognuna, quindi la somma supera il tempo totale del periodo.
      </Typhography>
    </div>
  );
};

export default CategoryBars;
